export default __webpack_public_path__ + "static/media/change.8b33c8a4.jpg";